import * as yup from 'yup'

export const ItemSchema = yup.object().shape({
  date: yup
    .date()
    .required('Ein Datum wird benötigt.'),
  description: yup
    .string()
    .required('Bitte eine Beschreibung angeben.'),
  amount: yup
    .number()
    .positive()
    .required('Bitte einen Betrag angeben.'),
  type: yup
    .number()
    .min(0)
    .required(),
  class_type: yup
    .number()
    .min(1),
  tax_type: yup
    .number()
    .min(1)
})
